<template>
    <div>支付</div>
</template>

<script>
export default {
    name:"PayIndex"
}
</script>

<style >

</style>